import { Background } from "./Background";
import { Cell } from "./Cell";
import { Mark } from "./Mark";
import { Stage } from "./Stage";

export const Wordopolis = {
  Background,
  Cell,
  Mark,
  Stage,
};
